import React from "react";
import grassBg from "../../../Assets/grassbgis.png";
import callimage from "../../../Assets/callimage.png";
import ImageComponent from "../../Image/ImageComponent";
import mail from "../../../Assets/email.png";
import map from "../../../Assets/map.png";
import swapUpper from "../../../Assets/swap upper.png";

const Footer = () => {
  return (
    <footer className="relative bg-[#0b3d2c] text-white pt-10">
      <div
        style={{
          backgroundImage: `url(${grassBg})`,
          backgroundPosition: "bottom",
          backgroundRepeat: "no-repeat",
          backgroundSize: "100% auto", // Full width, auto height
        }}
      >
        <div className="container mx-auto px-4 grid grid-cols-1 md:grid-cols-4 gap-8 p-4 pb-28">
          {/* About Us Section */}
          <div className="flex flex-col gap-6">
            <div>
              <h3 className="text-lg font-bold mb-2">ABOUT US</h3>
              <hr className="w-8 mb-2 border-t-2 border-[#2a7d2e]" />
              <p className="text-sm leading-relaxed text-[#8ea89f] mt-14">
                Your Tree Guy is your one-stop shop for all of your tree care
                needs. From questions to contractors, let us help you care for
                your trees like never before.
              </p>
            </div>
            <div className="flex items-center gap-2 mt-4">
              <div className=" flex items-center">
                <ImageComponent
                  src={callimage}
                  alt="callimage"
                  className={"w-12"}
                />
              </div>
              <div>
                <span className="text-[#8ea89f]">Emergency Call</span>
                <p className=" font-bold">911</p>
              </div>
            </div>
          </div>

          {/* Main Pages Section */}
          <div>
            <h3 className="text-lg font-bold mb-2">MAIN PAGES</h3>
            <hr className="w-8 mb-2 border-t-2 border-[#2a7d2e]" />
            <ul className="text-sm space-y-6 mt-14">
              <li>Home</li>
              <li>How It Works</li>
              <li>Services</li>
              <li>FAQ</li>
              <li>Contact Us</li>
            </ul>
          </div>

          {/* Our Services Section */}
          <div>
            <h3 className="text-lg font-bold mb-2">OUR SERVICES</h3>
            <hr className="w-8 mb-2 border-t-2 border-[#2a7d2e]" />
            <ul className="text-sm space-y-6 mt-14">
              <li>Tree Care Advice</li>
              <li>Diagnostics</li>
              <li>Dynamic Pricing</li>
              <li>Connect with an Arborist</li>
            </ul>
          </div>

          {/* Get in Touch Section */}
          <div>
            <h3 className="text-lg font-bold mb-2">GET IN TOUCH</h3>
            <hr className="w-8 mb-2 border-t-2 border-[#2a7d2e]" />
            <ul className="text-sm space-y-6 mt-14">
              <li className="flex items-center gap-2">
                <ImageComponent src={mail} alt={"mail"} />
                <span>tim@yourtreeguy.com</span>
              </li>
              <hr className="border-0 h-[1px] bg-white opacity-10" />
              <li className="flex gap-2">
                <ImageComponent src={map} alt={"map"} />
                <div>Tahoe Forestry Consulting LLC</div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className=" border-t border-green-800 p-4 text-sm flex justify-between items-center">
        <div className="text-[12px] md:text-lg font-bold">
          TAHOE FORESTRY CONSULTING, LLC
        </div>
        <div className="text-[10px] md:text-sm">
          <span className="text-[#a0b8b0]">© 2024</span> YourTreeGuy.
          <span className="text-[#a0b8b0]">All rights reserved</span>. |{" "}
          <a href="#Privacy Policy">Privacy Policy</a> |
          <a href="#Terms of Service">Terms of Service</a>
        </div>
        <div
          className="cursor-pointer"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          <ImageComponent src={swapUpper} alt="swapUpper" />
        </div>
      </div>

      {/* Scroll to Top Button */}
    </footer>
  );
};

export default Footer;
